module.exports = __webpack_public_path__ + "img/انگلیسی.c220f2be.png";